(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["k2-coffee-details"] && !Shopify.designMode) return;
  try {
    
(function () {
  function set(t) {
    if (!t || t === 'Default Title') return;
    document.querySelectorAll('[data-k2-cd-weight]').forEach(function (el) { el.textContent = t; });
  }
  function sync() {
    var o = document.querySelector('[data-kh-size-opt][aria-checked="true"]');
    if (o) set(o.getAttribute('data-size'));
  }
  document.addEventListener('kh:size', sync);
  document.addEventListener('variant:update', function (e) {
    var r = e.detail && e.detail.resource;
    if (r && r.title) set(r.title);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k2-welcome-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var d = document, J = 'k2-wo-joined', X = 'k2-wo-snooze';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) {} return null; }
  function pub(n, o) { try { var K = window.K2; if (K && K.publish) K.publish(n, o); else if (window.Shopify && Shopify.analytics) Shopify.analytics.publish(n, o); } catch (e) {} }
  function busy(g) {
    if (d.hidden) return true;
    var l = d.querySelectorAll('dialog[open],#cart-drawer[open],.k2-menu[open],[aria-modal="true"],#shopify-pc__banner'), a = d.activeElement;
    for (var i = 0; i < l.length; i++) if (l[i] !== g && l[i].getClientRects().length) return true;
    return !!(a && !g.contains(a) && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable));
  }
  function init() {
    var g = d.getElementById('k2-wo');
    if (!g || g.__k2wo || typeof g.showModal !== 'function') return;
    g.__k2wo = 1;
    var ret = null, sending = false, ed = g.hasAttribute('data-editor'), q = function (s) { return g.querySelector(s); };
    function state(st) {
      if (st === 'done' && !q('[data-k2wo-done]')) st = 'offer';
      g.setAttribute('data-state', st);
      g.setAttribute('aria-labelledby', st === 'done' ? 'k2-wo-h2' : 'k2-wo-h');
      return st;
    }
    function open(st, focus) {
      st = state(st);
      if (g.open) return;
      ret = d.activeElement;
      g.showModal();
      var f = q(focus || (st === 'done' ? '[data-k2wo-copy]' : '#k2-wo-h'));
      if (f) try { f.focus({ preventScroll: true }); } catch (e) {}
      if (!ed) pub('k2_welcome_offer_view', { state: st });
    }
    g.__k2open = open;
    var down = null;
    g.addEventListener('pointerdown', function (e) { down = e.target; });
    g.addEventListener('click', function (e) {
      var t = e.target;
      if ((t === g && down === g) || (t.closest && t.closest('[data-k2wo-close]'))) { g.close(); return; }
      var c = t.closest && t.closest('[data-k2wo-copy]');
      if (c) copy(c);
    });
    g.addEventListener('close', function () {
      if (!ed && !sending && g.getAttribute('data-state') !== 'done') ls(X, String(Date.now()));
      if (ret && ret.focus && d.contains(ret)) try { ret.focus({ preventScroll: true }); } catch (e) {}
    });
    g.addEventListener('submit', function (e) {
      var f = e.target;
      if (f.id !== 'k2-welcome-form') return;
      sending = true;
      try { sessionStorage.setItem('k2-wl-last', JSON.stringify({ id: f.id })); } catch (x) {}
      var b = f.querySelector('[type=submit]'); if (b) b.setAttribute('aria-busy', 'true');
      pub('k2_welcome_offer_submit', {});
    });
    function copy(btn) {
      var code = q('#k2-wo-code'), st = q('[data-k2wo-status]'), lab = q('[data-k2wo-copy-label]'), txt = code.textContent.trim();
      function ok() {
        st.textContent = st.getAttribute('data-ok');
        if (lab) { lab.__t = lab.__t || lab.textContent; lab.textContent = st.getAttribute('data-ok'); setTimeout(function () { lab.textContent = lab.__t; }, 2400); }
        pub('k2_welcome_offer_copy', {});
      }
      function fallback() {
        var r = d.createRange(), sel = getSelection(), done = false;
        r.selectNodeContents(code); sel.removeAllRanges(); sel.addRange(r);
        try { done = d.execCommand('copy'); } catch (e) {}
        if (done) ok(); else st.textContent = st.getAttribute('data-fallback');
      }
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
    }
    var sent = g.getAttribute('data-sent');
    if (sent === 'other' && !ed) return;
    if (sent === 'done' || sent === 'error') {
      if (sent === 'done') ls(J, '1');
      open(sent === 'done' ? 'done' : 'offer', sent === 'done' ? null : '#k2-wo-email');
      return;
    }
    if (ed) { if (g.getAttribute('data-editor')) open(g.getAttribute('data-editor')); return; }
    var delay = (parseFloat(g.getAttribute('data-delay')) || 6) * 1000, snooze = (parseFloat(g.getAttribute('data-snooze')) || 14) * 864e5, wasBusy = false;
    function tryOpen() {
      if (!g.isConnected || g.open || ls(J)) return;
      var t = +ls(X) || 0;
      if (t && Date.now() - t < snooze) return;
      if (busy(g)) { wasBusy = true; setTimeout(tryOpen, 800); return; }
      if (wasBusy) { wasBusy = false; setTimeout(tryOpen, 1200); return; }
      open('offer');
    }
    function arm() { setTimeout(tryOpen, Math.max(delay - performance.now(), 1000)); }
    if (d.readyState === 'complete') arm(); else addEventListener('load', arm, { once: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);
  d.addEventListener('shopify:section:select', function (e) { var g = e.target.querySelector && e.target.querySelector('#k2-wo'); if (g && g.__k2open) g.__k2open(g.getAttribute('data-editor') || 'offer'); });
  d.addEventListener('shopify:section:deselect', function (e) { var g = e.target.querySelector && e.target.querySelector('#k2-wo'); if (g && g.open) g.close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
